export default __webpack_public_path__ + "static/media/photo_5282747746622312912_y.31990333.jpg";